import { createContext, useContext, useEffect } from 'react';

export const SuperAdminLayoutContext = createContext(false);

export function useRequireSuperAdminLayout(pageName: string) {
  const isInsideSuperAdminLayout = useContext(SuperAdminLayoutContext);

  useEffect(() => {
    if (import.meta.env.DEV && !isInsideSuperAdminLayout) {
      console.warn(`${pageName} rendered outside SuperAdminLayout`);
    }
  }, [isInsideSuperAdminLayout, pageName]);

  return isInsideSuperAdminLayout;
}